import React, { useState, useEffect } from "react";
import { Button, Container, Card, Alert } from "react-bootstrap";
import { signInWithPopup, signOut } from "firebase/auth";
import { auth, provider } from "./firebase";
import './Login.css';

const Login = () => {
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        const storedError = localStorage.getItem("loginError");
        if (storedError) {
            setErrorMessage(storedError);
            localStorage.removeItem("loginError");
        }
    }, []);

    const handleSignIn = async () => {
        try {
            const result = await signInWithPopup(auth, provider);
            const user = result.user;
            // Allow only thrivve.me domain accounts
            if (!user.email.endsWith("@thrivve.me")) {
                localStorage.setItem("loginError", "Only thrivve.me email accounts are allowed.");
                await signOut(auth);
            }
        } catch (error) {
            console.error("Error during sign in:", error);
            setErrorMessage("Error signing in. Please try again.");
        }
    };

    return (
        <Container className="d-flex justify-content-center align-items-center vh-100">
            <Card className="p-5 shadow-lg text-center login-card">
                <h2 className="mb-4">Welcome to Team Ideas 💡</h2>
                {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
                <Button onClick={handleSignIn} variant="danger" size="lg" className="google-btn">
                    <i className="bi bi-google me-2"></i> Sign in with Google
                </Button>
            </Card>
        </Container>
    );
};

export default Login;
